// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h4>Company</h4>
          <a href="/about">About Us</a>
          <a href="/fleet">Our Fleet</a>
          <a href="/chauffeurs">Chauffeurs</a>
          <a href="/services">Services</a>
        </div>
        <div className="footer-column">
          <h4>Services</h4>
          <a href="/booking">Book a Ride</a>
          <a href="/services">Corporate Travel</a>
          <a href="/services">Airport Transfers</a>
          <a href="/support">Customer Support</a>
        </div>
        <div className="footer-column">
          <h4>Legal</h4>
          <a href="/terms">Terms of Service</a>
          <a href="/privacy">Privacy Policy</a>
        </div>
        <div className="footer-column">
          <h4>Contact Us</h4>
          <p>Address: PO BOX 190334, Dallas, TX 75219</p>
          <p>Phone: <a href="tel:2149842522">(214) 984-2522</a></p>
          <p>Email: <a href="mailto:ride@tacttransport.com">ride@tacttransport.com</a></p>
          <p>Service Area: Texas, Louisiana, Oklahoma.</p>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Tact Transport. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
